import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import RichTextEditor from "../../../formElement/RichTextEditor";
import {isRequiredQuestion, renderQuestion} from "../../../../../../utils";
import FormLabelElement from '../../../formElement/LabelFormElement'
import AggregatedDepotsSwitch
  from "../../../../../../../CustomerDashboardV2/components_v2/AggregatedDepotsSwitch/AggregatedDepotsSwitch";

export const RISK_STEP_LABEL = 'Der Kunde/die Kundin wurde zusätzlich über die folgenden Risiken informiert und aufgeklärt:';

const RiskStep = props => {
  const {
    onAnswerChange,
    questions: [
      risk,
      riskCredit,
      riskEmittent,
      riskTermination,
      riskEconomic,
      riskExchangeRate,
      riskLiquidity,
      riskSuspensionRedemption,
      riskCurrency,
      riskInterestRate,
      riskAdditional,
      riskAdditionalDetails
    ],
    dataService
  } = props;

  const riskCheckBoxesQuestions = [
    riskCredit, riskEmittent, riskTermination, riskEconomic, riskExchangeRate, riskLiquidity,
    riskSuspensionRedemption, riskCurrency, riskInterestRate, riskAdditional
  ]
  const allSelected = _.every(riskCheckBoxesQuestions, 'answer');

  const changeAllSelected = (value) => {
    riskCheckBoxesQuestions.forEach(q => q.answer = value)

    handleRiskAdditionalCheckboxChange(riskAdditional.uid, riskAdditional.answer);
  }

  const handleRiskAdditionalCheckboxChange = (uid, value) => {
    riskAdditionalDetails.disabled = riskAdditionalDetails.optional = !value;
    if(riskAdditionalDetails.disabled){
      riskAdditionalDetails.answer = null;
      riskAdditionalDetails.error = null;
    }
    onAnswerChange(uid, value);
  };

  React.useEffect(() => {
    handleRiskAdditionalCheckboxChange(riskAdditional.uid, riskAdditional.answer);
  }, []);

  return (
    <Grid container spacing={3}>
      {renderQuestion(risk, onAnswerChange, dataService)}
      <Grid item xs={12}>
        <Grid container spacing={1} justify={"space-between"} alignItems={"center"}>
          <Grid item>
            <FormLabelElement
              label={dataService.isNewDesign ? RISK_STEP_LABEL : "Der Kunde wurde zusätzlich über die folgenden Risiken informiert und aufgeklärt:"}
              required={false}
              customClasses={{labelRoot: 'bold no-padding'}}
            />
          </Grid>
          {dataService.isNewDesign && (
            <Grid item>
              <AggregatedDepotsSwitch
                title={"Alle"}
                flexDirection={'row-reverse'}
                value={allSelected}
                onChange={changeAllSelected}
              />
            </Grid>
          )}
        </Grid>
        <Grid container spacing={1}>
          {renderQuestion(riskCredit, onAnswerChange, dataService)}
          {renderQuestion(riskEmittent, onAnswerChange, dataService)}
          {renderQuestion(riskTermination, onAnswerChange, dataService)}
          {renderQuestion(riskEconomic, onAnswerChange, dataService)}
          {renderQuestion(riskExchangeRate, onAnswerChange, dataService)}
          {renderQuestion(riskLiquidity, onAnswerChange, dataService)}
          {renderQuestion(riskSuspensionRedemption, onAnswerChange, dataService)}
          {renderQuestion(riskCurrency, onAnswerChange, dataService)}
          {renderQuestion(riskInterestRate, onAnswerChange, dataService)}
          {renderQuestion(riskAdditional, handleRiskAdditionalCheckboxChange, dataService)}
          {(!dataService.isNewDesign || !riskAdditionalDetails.disabled) && (
            <Grid item xs={12}>
              <RichTextEditor
                uid={riskAdditionalDetails.uid}
                value={riskAdditionalDetails.answer || ''}
                onChange={(value) => onAnswerChange(riskAdditionalDetails.uid, value)}
                rows={13}
                disabled={riskAdditionalDetails.disabled || false}
                required={isRequiredQuestion(riskAdditionalDetails)}
                placeholder={riskAdditionalDetails.config && riskAdditionalDetails.config.placeholder}
                error={riskAdditionalDetails.error}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RiskStep;
